<template>
  <v-navigation-drawer app
    v-model="isActive"
    :width="$_width"
  >

    <template #prepend>
      <v-list color="primary" dark>
        <v-list-item>
          <v-list-item-avatar :color="$_avatar ? 'white' : 'primary'" size="32">
            <v-img :src="$_avatar">
              <v-icon color="white" x-large>mdi-account-circle-outline</v-icon>
            </v-img>
          </v-list-item-avatar>
        </v-list-item>

        <v-list-item>
          <v-list-item-content class="content">
            <v-list-item-title class="title text-wrap" style="height: auto;">
              {{empresa}}
            </v-list-item-title>
            <v-list-item-title class="title text-wrap pt-4" style="height: auto;">
              {{vendedorlogado}}
            </v-list-item-title>
            <div class="subtitle">
              <!-- LEMBRAR DE MUDAR NO SIGN-IN -->
              Versão: V172-150926-004-01
            </div>
            <div class="subtitle" v-if="dataatt">
              Última Carga: {{dataatt}}
              <v-icon v-if="icon" small class="aviso" color="error">{{icon}}</v-icon>
            </div>

            <!-- <v-list-item-subtitle>{{ $_user.email }}</v-list-item-subtitle> -->
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>

    <!-- <base-dialog>
      <v-dialog
        v-model="dialog"
        width="500"
      >
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Acesso Negado
          </v-card-title>

          <v-card-text>
              Você não possui permissão para acessar.
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="dialog = false"
            >
              I accept
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </base-dialog> -->

    <v-list dense :shaped="!minVariant">
      <template v-for="(item) in menu" >
        <v-list-item color="primary" :key="item.label" :to="item.route" >
          <v-list-item-icon>
            <v-icon >{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content >
            <v-list-item-title style='color:rgb(50,50,50)'>{{ item.label }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>

      <template>
        <v-list-item color="primary" class="sair">
          <v-list-item-icon>
            <v-icon>{{'mdi-exit-run'}}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title
            @click='$_getLogout'
            >
            {{ 'Sair' }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>

    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import MENU, { menuMapper } from '@/constants/MENUS';

import ToggleNavigationDrawerEvent from '@/events/ToggleNavigationDrawerEvent';
import db from '@/plugins/dexie';

// import BaseDialog from '@/components/core/dialog/Index.vue';

export default {
  name: 'LayoutDefaultNavigarionDrawer',

  components: {
    // BaseDialog,
  },

  data() {
    return {
      isActive: false,
      minVariant: false,
      empresa: null,
      vendedorlogado: null,
      menuArray: [],
      newMenu: [],
      dataatt: null,
      icon: null,
    };
  },

  computed: {
    ...mapGetters({
      $_user: 'auth/user',
    }),

    $_isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },

    $_width() {
      return this.$_isMobile ? null : 320;
    },

    $_avatar() {
      return this.$_user?.person?.avatar;
    },

    $_userName() {
      return this.$_user?.person?.name;
    },
  },

  methods: {
    ...mapActions({
      $_logout: 'auth/logout',
      $_empresa: 'empresa/find',
      $_geraModulo: 'modulos/metodoAcesso',
    }),

    $_onClickResumo() {
      window.close();
    },

    $_toggleMinVariant() {
      this.minVariant = !this.minVariant;
    },

    $_toggleNavigationDrawerHandler() {
      this.isActive = !this.isActive;
    },

    async $_getLogout() {
      await sessionStorage.clear();
      await this.$_logout();
      return window.location.reload();
    },

    async $_getEmpresa() {
      try {
        const param = await db.parametro.limit(1).first();

        if (param) {
          if (param.empresa) {
            this.empresa = param.empresa;
            this.showEmpresa = true;
          } else {
            this.showEmpresa = false;
            console.warn('Tabela parametro vazia ou sem campo empnome.');
          }

          if (param.idvendedorlogado) {
            const vendedores = await db.vendedor.toArray();
            const vendedorLogado = vendedores.find(v => 
              String(v.idvendedor) === String(param.idvendedorlogado) || 
              String(v.IdVendedor) === String(param.idvendedorlogado) || 
              String(v.id) === String(param.idvendedorlogado)
            );
            if (vendedorLogado) {
              this.vendedorlogado = vendedorLogado.nome || vendedorLogado.Nome;
            } else {
              this.vendedorlogado = null;
            }
          } else {
            this.vendedorlogado = null;
          }

          if (param.databaixado) {
            const dataObj = new Date(param.databaixado);
            
            this.dataatt = dataObj.toLocaleString('pt-BR', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit'
            });
          }
        } else {
          console.warn('Nenhum registro encontrado na tabela parametro.');
        }

      } catch (e) {
        // console.error("Erro ao carregar empresa do Dexie:", e);
        this.showEmpresa = false;
      }
    },

    async $_criaModulosMenu() {
      const menuArray = [];

      await this.$_Acesso(
        'LIBERA O LOGIN NO APP',
        'LOGIN_GERENCIAL',
        'LOGIN', 'APP',
      );

      for (let i = 1; i < this.menu.length; i += 1) {
        menuArray.push(this.$_Acesso(
          `LIBERA ${(this.menu[i].label).toUpperCase()} NO MENU`,
          `MENU_${(this.menu[i].label).toUpperCase()}`,
          'MENU', 'APP',
        ));
      }
      this.$_geraMenu((await Promise.all(menuArray)));
    },

    async $_geraMenu(tempMenu) {
      const newMenu = [];
      newMenu.push(this.menu[0]);
      setTimeout(() => {
        for (let i = 0; i < tempMenu.length; i += 1) {
          newMenu.push(this.menu[i + 1]);
        }
        this.menu = newMenu;
        this.isActive = !this.$_isMobile;
      }, 0);
    },

    async $_Acesso(descricao, rotina, programa, modulo) {
      const objModulo = {
        moddescmodulo: modulo,
        moddescprograma: programa,
        moddescrotina: rotina,
        moddescricao: descricao,
      };
      return this.$_geraModulo(objModulo);
    },

  },

  created() {
    this.$_getEmpresa();
    this.menu = menuMapper(this, MENU);
    this.$_criaModulosMenu();

    ToggleNavigationDrawerEvent.on(this.$_toggleNavigationDrawerHandler);
  },

  beforeDestroy() {
    ToggleNavigationDrawerEvent.off(this.$_toggleNavigationDrawerHandler);
  },

};
</script>

<style scoped>
    .content {
      width: 60vw;
      text-align: center;
    }

    .sair {
      cursor: pointer;
      transition: 0.2s;
    }

    .sair:hover {
      background-color: rgb(245, 245, 245);
    }

    .subtitle {
      font-size: 10px;
      margin-top: 10px;
    }

    .aviso {
      position: absolute;
      transform: translate(10px,-2px);
      background-color: white;
      border-radius: 100%;
    }
</style>
